module.exports = __webpack_public_path__ + "static/img/hm_section_stats_bg_alt.cd09b10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/healthMonitoring/hm_section_stats_bg_alt.png
// module id = 99WS
// module chunks = 1